import type React from 'react';
import { Icon } from './Icon.js';

/**
 * Edit and remove, as icons (owner, 26 September 2026: "replace all the edit buttons and remove
 * buttons with an edit icon or a trash bin"). One component so every list looks and behaves the
 * same: a pencil and a bin, quiet until hovered -- the bin turns red -- with the action named in
 * the tooltip and for screen readers ("Remove Break"), since an icon alone says nothing to either.
 */
export function RowAction({ kind, label, onClick, disabled }: {
  kind: 'edit' | 'delete';
  /** What the button does, to what: "Edit Sales team", "Remove Break". */
  label: string;
  onClick: () => void;
  disabled?: boolean | undefined;
}) {
  return (
    <button type="button" title={label} aria-label={label} disabled={disabled ?? false}
      className={`arc-btn arc-btn-ghost arc-btn-sm arc-btn-icon${kind === 'delete' ? ' arc-btn-danger-ghost' : ''}`}
      onClick={(e) => { e.stopPropagation(); onClick(); }}>
      <Icon name={kind === 'edit' ? 'edit' : 'trash'} size={14} />
    </button>
  );
}

/**
 * A table row that opens its item: one click, or Enter when it has the focus (UX review,
 * 21 October 2026: rows opened on double-click only, which nobody finds and a keyboard can't do).
 * The row's own buttons (RowAction) stop their click, so they never open it as well.
 */
export function openRowProps(open: () => void) {
  return {
    className: 'arc-clickable',
    tabIndex: 0,
    onClick: open,
    onKeyDown: (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' && e.target === e.currentTarget) { e.preventDefault(); open(); }
    },
  };
}
